import React from "react";
import RelationsPanel from "@/components/app/RelationsPanel";
import { Link as LinkIcon } from "@phosphor-icons/react";
import { PanelHeader } from "./_shared";

export default function ConnectionsPanel({ project }) {
  return (
    <div data-testid={`panel-connections-${project.id}`}>
      <PanelHeader icon={LinkIcon} title="Connected Records" subtitle="Tasks · finance · procurement · assets · team" />
      <RelationsPanel entityType="project" entityId={project.id} compact />
    </div>
  );
}
